import React, { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import PaginationWithControls from "../PaginationWithControls";

interface PageUrl {
  pageURLId: number;
  description: string;
  url: string;
}
interface ListPageUrlProps {
  pageUrlList: PageUrl[];
  resetFindOptions: () => void;
  findOptions: any;
  handleFindMapping: (findOptions: any) => void;
  handelDelete: (pageURLId: number) => void;
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
  handelEdit: (state: PageUrl) => void;
}

const ListPageUrl: React.FC<ListPageUrlProps> = ({
  pageUrlList,
  resetFindOptions,
  findOptions,
  handleFindMapping,
  handelDelete,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  onChangePageSize,
  handelEdit,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);

  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handelClearParameter = () => {
    setSearchOptions({
      pageURLId: null,
      description: "",
    });
    resetFindOptions();
  };

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  };
  const onClickFind = (findOptions: any) => {
    handleFindMapping(findOptions);
    handleModalClose();
  };

  return (
    <>
      <div className="float-end">
        <Button
          variant="primary"
          className="ml-1 mb-3"
          onClick={handleModalOpen}
        >
          Find Options
        </Button>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find Page URL</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              className="mb-3"
              variant="secondary"
              onClick={() => handelClearParameter()}
            >
              Clear Parameters
            </Button>
            <Form>
              <Form.Group className="mb-3" controlId="findState">
                <Form.Label>Page URL Id</Form.Label>
                <Form.Control
                  type="text"
                  value={searchOptions.pageURLId ? searchOptions.pageURLId : ""}
                  onChange={(e) =>
                    onChangeFieldValue({ pageURLId: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="findState">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    searchOptions.description ? searchOptions.description : ""
                  }
                  onChange={(e) =>
                    onChangeFieldValue({ description: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => onClickFind(searchOptions)}
            >
              Find
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Description</th>
            <th>Url</th>
          </tr>
        </thead>
        <tbody>
          {pageUrlList.map((pageUrl: PageUrl, index: number) => (
            <tr key={index}>
              <td>
                <Link to={`${pageUrl.pageURLId}`}>{pageUrl.pageURLId}</Link>
              </td>
              <td>
                <Link to={`${pageUrl.pageURLId}`}>{pageUrl.description}</Link>
              </td>
              <td>
                <a
                  href={pageUrl.url ? pageUrl.url : ""}
                  target="_blank"
                  rel="noreferrer"
                >
                  {pageUrl.url}
                </a>
              </td>
              <td>
                <Button onClick={() => handelEdit(pageUrl)}>Edit</Button>
              </td>
              <td>
                <Button
                  variant="danger"
                  onClick={() => handelDelete(pageUrl.pageURLId)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {pageUrlList.length > 0 ? (
        <>
          <PaginationWithControls
            pageIndex={pageIndex}
            pageSize={pageSize}
            listCount={totalItemCount}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
          />
        </>
      ) : (
        <p className="text-center py-3">No results found</p>
      )}
    </>
  );
};

export default ListPageUrl;
